import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { SearchField, LettersBar } from '../';

class SearchBar extends Component {
  componentDidMount() {
    window.addEventListener('scroll', this.stickyUI);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.stickyUI);
  }

  stickyUI = () => {
    const stickySearchTop = this.glossarySearch.offsetTop + 117;
    const scrollTop = window.scrollY;
    const stickySearchHeight = this.searchBar.offsetHeight;

    if (scrollTop > stickySearchTop) {
      this.searchBar.classList.add('sticky');
      this.glossarySearch.style.height = stickySearchHeight;
    } else {
      this.searchBar.classList.remove('sticky');
    }
  };

  render() {
    const { searchValue, onChangeSearch } = this.props;
    return (
      <section
        ref={el => {
          this.glossarySearch = el;
        }}
        className="glossary-search"
      >
        <div
          ref={el => {
            this.searchBar = el;
          }}
          className="search-bar"
        >
          <div className="container">
            <div className="row">
              <div className="col-xs-12">
                <SearchField
                  placeholder="Search terms"
                  value={searchValue}
                  onChange={onChangeSearch}
                />
                <LettersBar />
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

SearchBar.propTypes = {
  searchValue: PropTypes.string.isRequired,
  onChangeSearch: PropTypes.func.isRequired
};

export default SearchBar;



// WEBPACK FOOTER //
// ./src/pages/identity-glossary/components/SearchBar/SearchBar.js